import axios, { AxiosError } from "axios";
import {
	DEBUG,
	toaster,
	IRestParams,
	IRestCollectionParams,
	MediaType,
	RestAPI,
	IRestResult,
	WPMedia,
	IWPMedia,
	IErrorRestResponse,
	IRestDeleteParams,
} from "@/loader";

export interface IWPMediaRestGetParams extends IRestParams {
}

export interface IWPMediaRestCollectionParams extends IRestCollectionParams {
	search?: string;
	after?: string;
	before?: string;
	author?: number | number[];
	author_exclude?: number | number[];
	include?: number | number[];
	exclude?: number | number[];
	parent?: number | number[];
	parent_exclude?: number | number[];
	slug?: string | string[];
	status?: string | string[];
	media_type?: MediaType | MediaType[];
	mime_type?: string | string[];
}

export abstract class WPMediaRest {
	public static readonly endpoint: string = "media";

	public static getURL(id?: number) : string {
		let url: string[] = [RestAPI.url.replace(/\/$/, ""), RestAPI.wpNamespace, WPMediaRest.endpoint];
		if (id) {
			url.push(id.toString());
		}
		return url.join("/");
	}

	public static async list(params: IWPMediaRestCollectionParams = {}): Promise<IRestResult<WPMedia>> {
		if (!params.context) {
			params.context = "edit";
		}
		return await axios.get<IWPMedia[]>(WPMediaRest.getURL(), { params }).then(response => {
			return { success: true, items: response.data.map(x => new WPMedia(x)) };
		}).catch((error: AxiosError<IErrorRestResponse>) => {
			if (DEBUG) {
				console.log(error.response?.data);
			}
			toaster.toast({ message: error.response?.data.message || "", variant: "danger" });
			return <IRestResult<WPMedia>>{ success: false, error: error.response?.data };
		});
	}

	public static async get(id: number, params: IWPMediaRestGetParams = {}): Promise<IRestResult<WPMedia>> {
		if (!params.context) {
			params.context = "edit";
		}
		return await axios.get<IWPMedia>(WPMediaRest.getURL(id), { params }).then(response => {
			return { success: true, item: new WPMedia(response.data) };
		}).catch((error: AxiosError<IErrorRestResponse>) => {
			if (DEBUG) {
				console.log(error.response?.data);
			}
			toaster.toast({ message: error.response?.data.message || "", variant: "danger" });
			return <IRestResult<WPMedia>>{ success: false, error: error.response?.data };
		});
	}

	public static async create(data: WPMedia, file: File): Promise<IRestResult<WPMedia>> {
		const obj = data;
		data = obj.restData();

		let formData = new FormData();
		formData.append("file", file);
		for (let prop in data) {
			// @ts-ignore
			formData.append(prop, data[prop]);
		}
		// console.log(formData);

		return await axios.post<IWPMedia>(WPMediaRest.getURL(), formData, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
			obj.update(response.data);
			return { success: true, item: obj };
		}).catch((error: AxiosError<IErrorRestResponse>) => {
			if (DEBUG) {
				console.log(error.response?.data);
			}
			toaster.toast({ message: error.response?.data.message || "", variant: "danger" });
			return <IRestResult<WPMedia>>{ success: false, error: error.response?.data };
		});
	}

	public static async update(data: WPMedia): Promise<IRestResult<WPMedia>> {
		const obj = data;
		data = obj.restData();
		return await axios.post<IWPMedia>(WPMediaRest.getURL(obj.id), data).then(response => {
			obj.update(response.data);
			return { success: true, item: obj };
		}).catch((error: AxiosError<IErrorRestResponse>) => {
			if (DEBUG) {
				console.log(error.response?.data);
			}
			toaster.toast({ message: error.response?.data.message || "", variant: "danger" });
			return <IRestResult<WPMedia>>{ success: false, error: error.response?.data };
		});
	}

	public static async delete(data: IWPMedia | WPMedia, params?: IRestDeleteParams): Promise<IRestResult<WPMedia>> {
		return await axios.delete<IWPMedia>(WPMediaRest.getURL(data.id), { params }).then(response => {
			return { success: true };
		}).catch((error: AxiosError<IErrorRestResponse>) => {
			if (DEBUG) {
				console.log(error.response?.data);
			}
			toaster.toast({ message: error.response?.data.message || "", variant: "danger" });
			return <IRestResult<WPMedia>>{ success: false, error: error.response?.data };
		});
	}
}
